/** 江西维保签到信息路由。 */
export default {
  path: 'sign',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'jxxfWbSignIndex',
      component: () => import('@/features/jxxf/wb/sign/signList.vue'),
      meta: {
        navtabTitle: '维保签到信息',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};
